import React from "react";
import Lottie from "lottie-react";
import SpaceBoy from "../LottieFiles/SpaceBoy.json";
import Typed from "./Typed.js";
import Tilt from "react-parallax-tilt";
import Avatar from "../images/Avatar.png";
import { CiCoffeeCup } from "react-icons/ci";
import { IoBookOutline } from "react-icons/io5";

const Home = () => {
  return (
    <div>
      <div className="HomePage">
        <div className="HomeText">
          <h1>Hi There!</h1>
          <h1>
            I'M <b>Nguyen Dang Trung</b>
          </h1>
          <Typed />
        </div>

        <Lottie className="illustration" animationData={SpaceBoy} loop={true} />
      </div>

      <div className="AboutPage">
        <div className="AboutText">
          <h1 className="AboutTextHeading">
            Brief <b>introduction</b>
          </h1>
          <p>
            I'm a <b>frontend developer</b> with a solid understanding of
            backend technologies. I work with <b>Node.js</b> and <b>NestJS</b>,
            and I'm comfortable using both <b>SQL</b> and <b>NoSQL</b>{" "}
            databases.
            <br />
            <br />
            I enjoy turning ideas into real, usable products that make a
            difference. I'm always looking for work that challenges me as a
            developer and pushes me to grow.
            <br />
            <br />
            Currently, I’m working mainly with <b>React</b> and I’m actively
            leveling up my skills in <b>TypeScript</b> and <b>Next.js</b>. I
            also use <b>React Native</b> to build mobile applications.
            <br />
            <br />
            Also, I love <b>coffee</b>{" "}
            <CiCoffeeCup style={{ scale: "1.5", rotate: "15deg" }} /> and{" "}
            <b>reading</b> <IoBookOutline style={{ scale: "1.5" }} />
          </p>
        </div>
        <Tilt>
          <img className="Avatar" src={Avatar} alt="" />
        </Tilt>
      </div>
    </div>
  );
};

export default Home;
